import styled from 'styled-components';
import React from 'react';

import { Command, State, tabActions } from '@store/index';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Secrets } from '@common/Autocomplete/Secrets';
import { NodeField } from '@components/Flow/Nodes';
import { useSecrets } from '@common/hooks/useSecrets';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

interface Props {
  value: string;
  command: Command;
  field: NodeField;
  updateField: (value: string) => void;
}

export const SecretInput: React.FC<Props> = ({ value, command, field, updateField }) => {
  const { workflow_id } = useParams();
  const { secrets, loading, refetch } = useSecrets();

  const dispatch = useDispatch();
  const nodeErrors = useSelector((state: State) => state.tabs.active.nodeErrors);

  const error = nodeErrors?.find(
    (nodeError) =>
      nodeError.id === command.node.id &&
      nodeError?.workflowId === workflow_id &&
      nodeError?.fields?.find((nodeField) => nodeField.id === field.id)
  );
  const errorField = error ? error?.fields?.find((nodeField) => nodeField.id === field.id) : undefined;
  const errorFieldMessage = errorField ? errorField.message : undefined;

  const updateSecret = (value: string) => {
    updateField(value);
    dispatch(tabActions.setSaved(false));
  };

  return (
    <Container>
      <Secrets
        error={errorFieldMessage}
        refetch={refetch}
        value={value || ''}
        loading={loading}
        secrets={secrets.filter((secret) => secret.type === 'bearer')}
        onChange={(_, item) => updateSecret(item?.value.identifier || '')}
        placeholder='Secret Key'
      />
    </Container>
  );
};
